import Image from 'next/image'
import { usePreviousEventsQuery } from 'graphql/generated'
import moment from 'moment'
import ModalTrigger from 'components/common/ModalTrigger'
import VideoEmbedModal from 'components/VideoEmbedModal/VideoEmbedModal'
import PageScroll from 'components/common/PageScroll'

function DiscoverPreviousEvents() {
  const { data } = usePreviousEventsQuery({
    variables: {
      first: 50
    }
  })
  const events = data?.previousEvents || []

  if (!events.length) {
    return null
  }

  return (
    <div className="pt-10 pb-20 px-10 overflow-x-hidden">
      <p className="text-lg font-bold pb-10 text-gray-800">Previous Events</p>

      <PageScroll
        itemWidth={294}
        items={events.map((video, index) => (
          <ModalTrigger
            key={`${video.thumb}-${index}`}
            trigger={onClick => (
              <div
                className={`border border-gray-200 rounded-lg cursor-pointer p-4 h-full`}
                onClick={onClick}
              >
                <div className="relative overflow-hidden rounded-lg group">
                  <Image
                    alt={video.caption}
                    src={video.thumb}
                    width={264}
                    height={134}
                  />
                  <div
                    className="bg-no-repeat bg-center bg-[length:92px_92px] absolute inset-0 opacity-80 group-hover:opacity-100"
                    style={{
                      backgroundImage: 'url(/static/events/play_button.png)'
                    }}
                  />
                </div>

                <p className="text-sm text-gray-800 font-bold pt-2">
                  {video.caption}
                </p>

                <p className="text-xs text-gray-500 font-light pt-3">
                  {moment(video.createdAt).fromNow()}
                </p>
              </div>
            )}
          >
            <VideoEmbedModal
              title={video.caption}
              postedTimestamp={video.createdAt}
              url={video.url}
            />
          </ModalTrigger>
        ))}
      />
    </div>
  )
}

export default DiscoverPreviousEvents
